<ng-container *transloco="let t">
  <p-autocomplete
    [suggestions]="suggestions()"
    (completeMethod)="search($event)"
    (onSelect)="onSelect($event)"
    [placeholder]="t('search.searchProjects')"
    [minLength]="2"
    [delay]="300"
    class="!t-text-sm"
    optionLabel="title"
    inputStyleClass="!t-text-sm !t-py-1.5"
  >
    <ng-template let-project pTemplate="item">
      <div class="t-flex t-flex-col t-gap-1">
        <span class="t-font-semibold">{{ project.title }}</span>
        <span class="t-text-sm t-text-slate-500">
          {{ project.address.street }}, {{ project.address.city }}
        </span>
      </div>
    </ng-template>
  </p-autocomplete>
</ng-container>
